import React, { useContext, useEffect } from 'react'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import UserContext from '../../components/UserContext'
import { NextSeo } from 'next-seo'
import { EXPLORER_BASE_URL } from '../../config'
import StakingHome from '../../components/staking/StakingHome'
import StakingHero from '../../components/staking/Hero'
import { fetchGetMe } from '../../utils/client/auth/user-api'
import cookies from 'next-cookies'

export default function StakingPage(props) {
  const { scrollRef } = useContext(UserContext)
  const { accessToken, isLogin, userProfile } = props

  useEffect(() => {
    window.scrollTo(0, 0)
    const handleScrollPos = () => {
      scrollRef.current.scrollPos = window.scrollY
    }
    window.addEventListener('scroll', handleScrollPos)
    return () => {
      window.removeEventListener('scroll', handleScrollPos)
    }
  }, [])

  return (
    <>
      <NextSeo
        canonical={`${EXPLORER_BASE_URL}/staking`}
        openGraph={{
          url: `${EXPLORER_BASE_URL}/staking`,
        }}
      />
      <div className="min-h-[1000px]">
        <StakingHero />
        <StakingHome accessToken={accessToken} isLogin={isLogin} userProfile={userProfile} />
      </div>
    </>
  )
}

export async function getServerSideProps(ctx) {
  const isSSR = ctx.req !== null && ctx.req !== undefined
  const { key_user_accesstoken } = cookies(ctx)

  let isLogin = false
  let userProfile = null

  if (key_user_accesstoken) {
    const myProfileResponse = await fetchGetMe(key_user_accesstoken, isSSR)
    if (myProfileResponse && myProfileResponse.status === 200 && myProfileResponse.data) {
      isLogin = true
      userProfile = myProfileResponse.data
    }
  }

  return {
    props: {
      isSSR,
      accessToken: key_user_accesstoken || null,
      isLogin,
      userProfile,
      ...(await serverSideTranslations(ctx.locale, ['common', 'index'])),
    },
  }
}
